import { useNavigate } from 'react-router-dom';
import React, { useState, useRef, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useSwipeable } from 'react-swipeable';
import { useAppContext } from '../../Context';
import { useTranslation } from '../../TranslationContext';
import ConfirmDialog from './ConfirmDialog';

function ImageModal() {
	const navigate = useNavigate();
	const { psServer, submittedCode, showModal, gallery, setIsConfirmDialogOpen, setShowModal, modalImageIndex, setModalImageIndex, setStartDownloadInd, isLoading, setIsLoading } = useAppContext();
	const { t } = useTranslation();
	const [modalImageSrc, setModalImageSrc] = useState(null);
	const directionRef = useRef(null);
	const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
	
	const handlers = useSwipeable({
		onSwipedLeft: () => {
			directionRef.current = "left";
			setModalImageIndex((prevIndex) => {
				let newIndex = (prevIndex + 1) % gallery.length;
				while (gallery[newIndex].bought === 0 && newIndex !== prevIndex) {
					newIndex = (newIndex + 1) % gallery.length;
				}
				return newIndex;
			});
		},
		onSwipedRight: () => {
			directionRef.current = "right";
			setModalImageIndex((prevIndex) => {
				let newIndex = (prevIndex - 1 + gallery.length) % gallery.length;
				while (gallery[newIndex].bought === 0 && newIndex !== prevIndex) {
					newIndex = (newIndex - 1 + gallery.length) % gallery.length;
				}
				return newIndex;
			});
		},
	});
	function handleMediaLoad() {
		setIsLoading(false);
	}
	useEffect(() => {
		if (gallery !== null && modalImageIndex !== null) {
			const fileName = gallery[modalImageIndex].fileName;
			const actNewSrc = `${psServer}/media/file/${submittedCode}/${fileName}/get`;
			setModalImageSrc(actNewSrc);
			if (showModal) {
				setIsLoading(true);
			}
		}
	}, [modalImageIndex, setModalImageSrc, gallery, showModal]);

	const handleIsntMe = () => {
		setIsConfirmDialogOpen(true);
	};
	
	const handleConfirmIsntMe = async() => {
		try {
			const parts = modalImageSrc.split('/');
			const fileName = parts[parts.length - 2];
			const response = await fetch(`${psServer}/ui/customer/${fileName}/isntme`, {
				method: 'GET',
				headers: {
					'Content-Type': 'application/json',
				}
			});
			const jsonData = await response.json();
			navigate('/?qr=' + submittedCode);
			window.location.reload();
		} catch (error) {
			console.error('Error fetching data:', error);
		}
		setIsConfirmDialogOpen(false);
	};
	
	function closeModal() {
		setShowModal(false);
	}
	
	function onDownload(modalImageSrc) {
		setStartDownloadInd(modalImageSrc);
	}

	return (
		<>
			<ConfirmDialog
				message={t('notYours')}
				onConfirm={handleConfirmIsntMe}
			/>
			<motion.div
				initial={{ opacity: 0 }}
				animate={{ opacity: isLoading ? 0 : 1 }}
				exit={{ opacity: 0 }}
				transition={{ duration: 0.5, ease: "easeInOut" }}
				className="modalOverlay"
				onClick={closeModal}
				{...handlers}
			>
					<motion.div
						initial={{ opacity: 0 }}
						animate={{ opacity: 1 }}
						exit={{ opacity: 0 }}
						transition={{ duration: 0.5, ease: "easeInOut" }}
						className="modalWrap"
					>
						<motion.div
							key={modalImageIndex}
							initial={{ x: directionRef.current === "left" ? 200 : -200, opacity: 0 }}
							animate={{ x: 0, opacity: 1 }}
							exit={{ scale: 0, opacity: 0 }}
							transition={{ duration: 0.5, ease: "easeInOut" }}
							className="modalContent"
							onClick={(e) => e.stopPropagation()}
						>
							<span className="isntMe" onClick={handleIsntMe}>Don't recognise this image?</span>
							{gallery[modalImageIndex].fileName.endsWith('.mp4') ? (
								<video
									controls 
									playsInline={true}
									muted={true}
									preload="auto"
									onLoadedData={handleMediaLoad}
									key={modalImageSrc}
								>
									<source
										src={modalImageSrc}
										type='video/mp4'
									/>
								</video>
							) : (
								<img src={modalImageSrc}
									alt=""
									onLoad={handleMediaLoad}
									key={modalImageSrc}
								/>
							)}
							<div className="buttons">
								<button onClick={() => onDownload(modalImageSrc)}>{t('modalDownload')}</button>
								<button onClick={closeModal}>{t('modalClose')}</button>
							</div>
							{isIOS && (
								<p className="appleMessage">{t('modalIosMessage')}</p>
							)}
						</motion.div>
					</motion.div>
			</motion.div>
		</>
	);
}

export default ImageModal;